import React from 'react';
import { Button as MuiButton } from '@mui/material';
import { useIntl } from 'react-intl';

const Button = ({ provider, children, ...props }: any) => {
  const intl = useIntl();

  return (
    <MuiButton
      aria-label={intl.formatMessage({ id: 'AUTH.ARIA_AUTHENTICATE_WITH' }, { provider: provider })}
      size="large"
      variant="outlined"
      color="primary"
      {...props}
    >
      {children}
    </MuiButton>
  );
};

export default Button;
